import { SagaIterator } from 'redux-saga';
import { takeLatest } from 'redux-saga/effects';
import {
  getReportsList,
  getObjectionNextStep,
  getReportSettings,
  checkDynamicCatalogData,
  getReport,
} from '../model/actions';
import {
  fetchReportListWorker,
  fetchObjectionNextStepWorker,
  fetchReportSettingsWorker,
  fetchcheckDynamicCatalogDataWorker,
  getReportByFilterWorker,
} from './workers';

export default function* watchReportBuilder(): SagaIterator {
  yield takeLatest(getReportsList, fetchReportListWorker);
  yield takeLatest(getObjectionNextStep, fetchObjectionNextStepWorker);
  yield takeLatest(getReportSettings, fetchReportSettingsWorker);
  yield takeLatest(checkDynamicCatalogData, fetchcheckDynamicCatalogDataWorker);
  yield takeLatest(getReport, getReportByFilterWorker);
}
